import React from "react";
import { Home, Egg, HeartPulse, ShieldCheck, Users, Headphones, LifeBuoy, Truck, Syringe, Award } from "lucide-react";
import { useContent } from "../context/ContentContext";

const iconMap = { Home, Egg, HeartPulse, ShieldCheck, Users, Headphones, LifeBuoy, Truck, Syringe, Award };

const Features = () => {
  const { content } = useContent();
  const items = content.features || [];

  return (
    <section className="relative -mt-20 z-20 px-6 max-w-7xl mx-auto">
      <div className="grid md:grid-cols-3 gap-6">
        {items.map((f) => {
          const Icon = iconMap[f.icon] || Home;
          return (
            <div key={f.id} className="group bg-white rounded-2xl p-8 shadow-xl border border-slate-100 hover:-translate-y-2 hover:shadow-2xl transition-all duration-300">
              <div className="w-14 h-14 rounded-xl bg-[#b91c1c] flex items-center justify-center mb-5 group-hover:rotate-[-6deg] transition-transform">
                <Icon className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-xl font-bold text-[#b91c1c] mb-3 leading-tight">{f.title}</h3>
              <p className="text-slate-600 text-sm leading-relaxed">{f.desc}</p>
              <div className="mt-5 h-1 w-12 bg-[#b91c1c]/15 rounded group-hover:w-20 group-hover:bg-[#b91c1c] transition-all" />
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Features;
